<div class="modal-header" *ngIf="!print">
  <h4 class="modal-title pull-left">{{labels[titleId]}}</h4>
  <button type="button" class="btn-close close pull-right" aria-label="Close" (click)="onCloseModal()">
    <span aria-hidden="true" class="visually-hidden">&times;</span>
  </button>
</div>
<div [ngClass]="{'modal-body': !print, 'print-page':print}" >
  <section *ngIf="titleId == 'executionIndicator'" class="executionDiv">
    <table *ngIf="(currentIndicator?.execucao_orcamentaria_atribuicao?.length ?? 0) > 0 ">
      <thead>
        <tr>
          <th class="text-center">Exercício</th>
          <th class="text-center">Empenhado</th>
          <th class="text-center">Liquidado</th>
          <th class="text-center">Pago</th>
        </tr>
      </thead>
      <tbody>
        <ng-container *ngFor="let item of orderData2(currentIndicator?.execucao_orcamentaria_atribuicao)">
          <tr *ngIf="item?.execucao_orcamentaria_resultados_totais?.[0] as execucao" >
            <td class="text-center">{{item?.execucao_orcamentaria?.ano_exercicio}}</td>
            <td class="text-center">{{ execucao?.empenhado ?? 0 | number:'1.2-2'}}</td>
            <td class="text-center">{{ execucao?.liquidado ?? 0 | number:'1.2-2'}}</td>
            <td class="text-center">{{ execucao?.pago ?? 0 | number:'1.2-2'}}</td>
          </tr>
        </ng-container>
      </tbody>
    </table>
    <div  *ngIf="(currentIndicator?.execucao_orcamentaria_atribuicao?.length ?? 0) == 0 && !print">
      Nenhuma Execução Orçamentária
    </div>
  </section>
  <section *ngIf="titleId == 'executionProject'" class="executionDiv">
    <table *ngIf="(currentIndicator?.project?.execucao_orcamentaria?.length ?? 0) > 0 ">
      <thead>
        <tr>
          <th class="text-center">Exercício</th>
          <th class="text-center">Total Previsto</th>
          <th class="text-center">Dotação Loa</th>
          <th class="text-center">Empenhado</th>
          <th class="text-center">Liquidado</th>
          <th class="text-center">Pago</th>
        </tr>
      </thead>
      <tbody>
        <ng-container  *ngFor="let item of orderData(currentIndicator?.project?.execucao_orcamentaria)" >
          <tr *ngIf="item?.execucao_orcamentaria_resultados_totais_por_execucao as execucao">
            <td class="text-center">{{ item?.ano_exercicio }}</td>
            <td class="text-center"> {{ item?.valor_planejado ?? 0 | number:'1.2-2' }}</td>
            <td class="text-center"> {{ item?.execucao_orcamentaria_dotacao?.total_dotacao ?? 0 | number:'1.2-2'}}</td>
            <td class="text-center">{{ execucao?.total_empenhado ?? 0 | number:'1.2-2'}}</td>
            <td class="text-center">{{ execucao?.total_liquidado ?? 0 | number:'1.2-2'}}</td>
            <td class="text-center">{{ execucao?.total_pago ?? 0 | number:'1.2-2'}}</td>
          </tr>
        </ng-container>
      </tbody>
    </table>
    <div  *ngIf="(currentIndicator?.project?.execucao_orcamentaria?.length ?? 0) == 0 && !print">
      Nenhuma Execução Orçamentária
    </div>
  </section>
  <section *ngIf="titleId == 'managerIndicator'" class="managerDiv">
    
    <ng-container *ngTemplateOutlet="tempManager; context: { $implicit: { person: currentIndicator?.pf_ind_manager_main?.tb_pss_pessoa, title: 'Responsável' } }">
    </ng-container>
    
    <ng-container *ngFor="let manager of currentIndicator?.pf_ind_manager_not_main">
      <ng-container *ngTemplateOutlet="tempManager; context: { $implicit: { person: manager?.tb_pss_pessoa, title: 'Adjunto' } }">
      </ng-container>
    </ng-container>
  </section>
  <section *ngIf="titleId == 'managerProject'" class="managerDiv">
    <ng-container *ngTemplateOutlet="tempManager; context: { $implicit: { person: currentIndicator?.project?.pf_manager_main?.tb_pss_pessoa, title: 'Responsável' } }">
    </ng-container>
    <ng-container *ngTemplateOutlet="tempManager; context: { $implicit: { person: currentIndicator?.project?.tb_pss_pessoa, title: 'Assessor' } }">
    </ng-container>
    <ng-container *ngFor="let manager of currentIndicator?.project?.pf_manager_not_main">
      <ng-container *ngTemplateOutlet="tempManager; context: { $implicit: { person: manager?.tb_pss_pessoa, title: 'Adjunto' } }">
      </ng-container>
    </ng-container>
  </section>
  <section *ngIf="titleId == 'monitoringDemand'">
    <form [formGroup]="form" (ngSubmit)="salvar()" (keydown.enter)="onKeydownEnter($event)">
      <h3>{{currentIndicator?.title}}</h3>
      <div class="col-md-12 section-field">
        <label class="col-12 pb-1">Titulo:<sup class="text-danger">*</sup></label>
        <input class="form-control" formControlName="subject">
        <app-field-message [field]="fieldMessageRequired('subject')" [erros]="fieldErros('subject')"></app-field-message>
      </div>
      <div class="col-md-12">
        <label class="col-sm-12 pb-1">Descrição:</label>
        <textarea id="description" class="form-control" formControlName="description" ></textarea>
        <app-field-message [field]="fieldMessageRequired('description')" [erros]="fieldErros('description')"></app-field-message>
      </div>
      <div class="col-md-12">
        <label class="col-sm-12 pb-1">Órgão demandado: <b>{{currentIndicator?.agency?.str_nome}} - {{currentIndicator?.agency?.str_sigla}}</b></label>
        
      </div>
      
      <div class="col-md-8 section-field">
        <label class="col-sm-12 pb-1">Demandado titular:</label>
        <ng-select id="pf_ind_manager_main" class="ng-select-alternative" [items]="filters?.person" 
          bindLabel="label" bindValue="id" placeholder="Selecione" formControlName="pf_ind_manager_main">
        </ng-select>
        <app-field-message [field]="fieldMessageRequired('pf_ind_manager_main')" [erros]="fieldErros('pf_ind_manager_main')"></app-field-message>
      </div>
      <div class="col-md-8 m-b section-field">
        <label class="col-sm-12 pb-1">Demandado adjunto:</label>
        <div formArrayName="pf_ind_manager_not_main" class="w-100 row g-0">
          <div *ngFor="let item of getFormArray('pf_ind_manager_not_main').controls; let i = index" class="m-b row g-0 ">
            <div class="col-10 col-sm-11">  
              <ng-select [id]="'pf_ind_manager_not_main_'+i" class="ng-select-alternative" [items]="filters?.person" 
              bindLabel="label" bindValue="id" placeholder="Selecione" [formControlName]="i" [compareWith]="compareCPF">
            </ng-select>
            </div>
            <div class="div-button col-2 col-sm-1">
              <div class="d-flex justify-content-end">
                <button class="btn btn-font-icon" type="button" (click)="removeItem('pf_ind_manager_not_main', i)" alt="Remover órgão fixo">
                  delete
                </button>
              </div>
            </div>
          </div>
        </div>
        <button class="btn btn-primary btn-new-agency" type="button" (click)="addItem('pf_ind_manager_not_main')" alt="Adicionar órgão participante">
          Novo Demandado Adjunto
        </button>
        <app-field-message [field]="fieldMessageRequired('pf_ind_manager_not_main')" [erros]="fieldErros('pf_ind_manager_not_main')"></app-field-message>
      </div>
      
      <div class="col-md-4 section-field">
        <label class="col-sm-12 pb-1">Situação:</label>
        <ng-select id="issue_stat_id" class="ng-select-alternative" [items]="filters?.statsLst" 
          bindLabel="label" bindValue="id" placeholder="Selecione" formControlName="issue_stat_id">
        </ng-select>
        <app-field-message [field]="fieldMessageRequired('issue_stat_id')" [erros]="fieldErros('issue_stat_id')"></app-field-message>
      </div>
      <div class="col-md-4 section-field">
        <label class="col-12 pb-1">Prazo:<sup class="text-danger">*</sup></label>
        <input  #datepickerYMD="bsDatepicker" bsDatepicker  [bsConfig]="{ dateInputFormat: 'DD/MM/YYYY', locale: 'pt-br' }" class="form-control" formControlName="dt_foreseen_end" placeholder="dd/mm/aaaa" (change)="dataMask($event, 'dt_foreseen_end')">
        <app-field-message [field]="fieldMessageRequired('dt_foreseen_end')" [erros]="fieldErros('dt_foreseen_end')"></app-field-message>
      </div>
      <div class="form-group row d-flex justify-content-end">
        <div class="col-sm-8 col-sm-offset-2 d-flex justify-content-end">
          <button class="btn btn-white m-r-xs" type="button" (click)="onCloseModal()">Cancelar</button>
          <button class="btn btn-primary" type="submit">Salvar</button>
        </div>
      </div>
    </form>
  </section>
  <section *ngIf="titleId == 'achievementAndGoal'">
    <div class="row g-0"> 
      <section class="col-md-6 pe-0 pe-md-2 pb-2 pb-md-0"> 
        <div class="section-bar div-expand">
          <h3>
            Atingimento de Metas
          </h3>
          <div class="body-chart ">
            <div *ngFor="let chart of achievementChart">
              <canvas baseChart #baseChart class="chart chart-bar" [data]="chart?.data" [options]="chart?.options" [type]="chart?.type" [plugins]="chart?.plugins"></canvas>
            </div>
          </div>
          <hr class="space-expand">
          <div class="label-chart-bar">
            <ul class="label-bar-chart">
              <li *ngFor="let item of patternAchievement">
                <div class="dot" [ngStyle]="{'background-color': item.color}"></div>
                <span class="me-2">{{item.label}}</span>
              </li>
            </ul>
          </div>
        </div>
      </section>
      <section class="col-md-6 ps-0 ps-md-2 pt-2 pt-md-0"> 
        <div class="section-bar div-expand">
          <h3>
            Projeção das Metas
          </h3>
          <div class="body-chart ">
            <div *ngFor="let chart of projectionChart">
              <canvas baseChart #baseChart class="chart chart-bar" [data]="chart?.data" [options]="chart?.options" [type]="chart?.type" [plugins]="chart?.plugins"></canvas>
            </div>
          </div>
          <hr class="space-expand">
          <div class="label-chart-bar ">
            <ul class="label-bar-chart">
              <li *ngFor="let item of patternProjection">
                <div class="dot" [ngStyle]="{'background-color': item.color}"></div>
                <span class="me-2">{{item.label}}</span>
              </li>
            </ul>
          </div>
        </div>
      </section>
    </div>
  </section>
  <section *ngIf="titleId == 'actions'">
    <div class="div-actions" *ngFor="let action of currentCritical.pf_ind_action">
      <div class="break-word td-description">
        <p>
          {{action.title}}
          <b>Atualização: {{action?.ctr_dth_atu | date: 'dd/MM/YYYY'}}</b>
        </p>
        
      </div>
    </div>
  </section>
</div>
<ng-template #tempManager let-data>
  <div class="manager-div" *ngIf="data.person">
    <span><b>{{data.title}}:</b> {{data.person?.str_nome}}</span>
    <span><b>E-mail:</b> {{data.person?.str_email_responsavel_projeto}}</span>
    <span *ngIf="data.person?.num_telefone_1">
      <b>Telefone:</b> <span *ngIf="data.person?.num_ddd_1">({{data.person?.num_ddd_1}})</span> {{data.person?.num_telefone_1}}
    </span>
  </div>
  <hr *ngIf="!print">
</ng-template>
<app-loading [loader]="isLoading"></app-loading>
        